<template>
  <div class="banner" :style="{ backgroundImage: bannerBgImage }">
    <!-- 无文字，只显示背景图 -->
  </div>
</template>

<script>
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";

export default {
  name: 'Banner',
  props: {
    // location: 1-首页 2-套餐 3-充值 4-企业通道
    location: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data() {
    return {
      bannerBgImage: ''
    }
  },
  created() {
    this.getBannerList()
  },
  methods: {
    getBannerList() {
      let data = {
        location: this.location
      }
      request({
        method: "get",
        url: Apis.getBannerList,
        params: data,
        _type: 1,
      }).then(res => {
        if (res.code == 0 && res.data && res.data.length > 0) {
          // 使用接口返回的第一张图片作为背景
          this.bannerBgImage = `url('${res.data[0].image}')`
        } else {
          // 默认背景图（可选）
          this.bannerBgImage = ''
        }
      }).catch(err => {
        console.error('获取 banner 失败:', err)
        this.bannerBgImage = ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 260px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
